/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_len_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A nautical mile (1,852 meters) is based on one minute of latitude on Earth's surface and is used for sea and air navigation. A regular (statute) mile is 1,609.344 meters and is used for road distances. They're about 15% apart, so don't mix them up when reading a chart.`)
};

const es_uc_len_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una milla náutica (1,852 metros) se basa en un minuto de latitud en la superficie de la Tierra y se utiliza para navegación marina y aérea. Una milla regular (estatutaria) es 1,609.344 metros y se utiliza para distancias por carretera. Están aproximadamente 15% separadas, así que no las mezcles cuando leas un gráfico.`)
};

const de_uc_len_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Seemeile (1,852 Meter) basiert auf einer Bogenminute Breitengrad auf der Erdoberfläche und wird für die See- und Luftfahrt-Navigation verwendet. Eine gewöhnliche Meile (statute mile) sind 1,609.344 Meter und wird für Straßenentfernungen genutzt. Sie liegen etwa 15% auseinander — verwechseln Sie sie also nicht beim Lesen einer Karte.`)
};

const nl_uc_len_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een zeemijl (1.852 meter) is gebaseerd op één minuut breedteligging op het aardoppervlak en wordt gebruikt voor zee- en luchtvaart. Een normale (wet) mijl is 1.609,344 meter en wordt gebruikt voor wegafstanden. Ze liggen ongeveer 15% uit elkaar, dus verwar ze niet als u een kaart leest.`)
};

const fr_uc_len_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un mille nautique (1 852 mètres) est basé sur une minute de latitude à la surface de la Terre et est utilisé pour la navigation maritime et aérienne. Un mile régulier (statutory mile) est 1 609,344 mètres et est utilisé pour les distances routières. Ils sont environ 15 % à part, alors ne les confondez pas en lisant une carte.`)
};

const it_uc_len_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un miglio nautico (1.852 metri) si basa su un minuto di latitudine sulla superficie della Terra ed è utilizzato per la navigazione marina e aerea. Un miglio regolare (statuario) è 1.609.344 metri ed è utilizzato per le distanze stradali. Sono circa il 15% distanti, quindi non confonderli quando leggi una carta.`)
};

const pt_br2_uc_len_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma milha náutica (1.852 metros) é baseada em um minuto de latitude na superfície da Terra e é usada para navegação marítima e aérea. Uma milha (estatutária) regular é 1.609.344 metros e é usada para distâncias rodoviárias. Elas estão cerca de 15% distantes, então não as misture ao ler um gráfico.`)
};

const pt_uc_len_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma milha náutica (1852 metros) é baseada num minuto de latitude na superfície da Terra e é utilizada para navegação marítima e aérea. Uma milha comum (estátuto) é 1609,344 metros e é utilizada para distâncias rodoviárias. Estão cerca de 15% separadas, portanto não as misture quando ler um gráfico.`)
};

const ja_uc_len_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`海里(1,852メートル)は地球の表面の1分の緯度に基づいており、海洋と航空ナビゲーションで使用されます。通常のマイルは1,609.344メートルで、道路距離に使用されます。それらは約15%離れているため、チャートを読むときにそれらを混ぜないでください。`)
};

const zh_uc_len_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_len_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_len_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_len_faq3_a", locale)
	if (locale === "en") return en_uc_len_faq3_a(inputs)
	if (locale === "es") return es_uc_len_faq3_a(inputs)
	if (locale === "de") return de_uc_len_faq3_a(inputs)
	if (locale === "nl") return nl_uc_len_faq3_a(inputs)
	if (locale === "fr") return fr_uc_len_faq3_a(inputs)
	if (locale === "it") return it_uc_len_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_len_faq3_a(inputs)
	if (locale === "pt") return pt_uc_len_faq3_a(inputs)
	if (locale === "ja") return ja_uc_len_faq3_a(inputs)
	return zh_uc_len_faq3_a(inputs)
};